import { Box, type Inline } from 'braid-design-system';
import { vars } from 'braid-design-system/css';

import * as styles from '../JobAdFeatureChart.css';

export const TableCellBox = ({
  alignY,
  align,
  embed,
  children,
}: {
  alignY?: React.ComponentProps<typeof Inline>['alignY'];
  align?: React.ComponentProps<typeof Inline>['align'];
  embed?: boolean;
  children: React.ReactNode;
}) => (
  <Box
    paddingY={{ mobile: 'xsmall', desktop: 'small' }}
    paddingX={{ mobile: 'xxsmall', desktop: 'small' }}
    display="flex"
    alignItems={alignY === 'top' ? 'flexStart' : 'center'}
    justifyContent={align === 'left' ? 'flexStart' : 'center'}
    style={{
      color: embed
        ? vars.foregroundColor.brandAccentLight
        : vars.backgroundColor.neutralLight,
    }}
    className={styles.tableCell}
  >
    {children}
  </Box>
);

export const TableRow = ({
  embed,
  children,
  colNum,
}: {
  embed?: boolean;
  children: React.ReactNode;
  colNum: 4 | 5;
}) => (
  <Box
    style={{
      color: embed
        ? vars.foregroundColor.brandAccentLight
        : vars.backgroundColor.neutralLight,
    }}
    className={colNum === 4 ? styles.tableRow : styles.tableRow5Col}
  >
    {children}
  </Box>
);
